import { useParams, useSearchParams } from 'react-router-dom';

import { PUBLIC_SHORTLIST_CODE_QUERY_PARAM } from '@/modules/public-shortlist/constants';

interface ValidShortlistParams {
  isValid: true;
  code: string;
}

interface InvalidShortlistParams {
  isValid: false;
  code: string;
}

type ParsedShortlistParams = ValidShortlistParams | InvalidShortlistParams;

function parseShortlistParams(
  company?: string,
  roleName?: string,
  code?: string,
): ParsedShortlistParams {
  if (!company?.trim() || !roleName?.trim() || !code?.trim()) {
    return { isValid: false, code: '' };
  }

  return {
    isValid: true,
    code,
  };
}

export function useShortlistRouteParams() {
  const { company, roleName, candidateJobId } = useParams<{
    company: string;
    roleName: string;
    candidateJobId?: string;
  }>();
  const [searchParams] = useSearchParams();
  const code = searchParams.get(PUBLIC_SHORTLIST_CODE_QUERY_PARAM) ?? '';

  return {
    candidateJobId,
    code,
    company,
    params: parseShortlistParams(company, roleName, code),
    roleName,
    search: searchParams.toString(),
  };
}
